import Vue from 'vue';
import App from './App';
import { formatDate } from '../../js/date.js';
import router from '../../router';
import VueResource from 'vue-resource';
import Mint from 'mint-ui';
import 'mint-ui/lib/style.css';
import '../../style/common.css';
import '../../js/jquery-1.11.3.min.js';
import '../../js/md5.js';
import { default as domain } from '../../js/domain.js';
import { interceptors } from '../../js/interceptors.js';
import { Toast, MessageBox } from 'mint-ui';
import store from '@/store/index'
// import Vconsole from 'vconsole';
// var vConsole = new Vconsole();
// // export default vConsole;
import filters from '../../filters'; // vue过滤器
global.domain = domain;
// 全局过滤器
Object.keys(filters).forEach((filterName) => {
    Vue.filter(filterName, filters[filterName]);
});
Vue.use(Mint);
Vue.config.productionTip = false;
Vue.use(VueResource);
Vue.http.options.emulateJSON = true;
import { TsaDialog, TsaSignPassword, TsaSignPasswordV2, TsaAgreement, TsaLoading, TsaSetOrForgetPassword, TsaPersonRealNameInfoVerify, TsaCompanyRealNameInfoVerify, TsaHandlerInfoVerify, TsaDigitalCertificateAgreement, TsaAuthorizationLetter, TsaHandlerVerifySuccess, TsaAuthorizationCode, TsaEnvironmentCheck } from '../../plugins/index'
Vue.use(TsaDialog).use(TsaSignPassword).use(TsaSignPasswordV2).use(TsaAgreement).use(TsaLoading).use(TsaSetOrForgetPassword).use(TsaPersonRealNameInfoVerify).use(TsaCompanyRealNameInfoVerify).use(TsaHandlerInfoVerify).use(TsaDigitalCertificateAgreement).use(TsaAuthorizationLetter).use(TsaHandlerVerifySuccess).use(TsaAuthorizationCode).use(TsaEnvironmentCheck)
router.beforeEach((to, from, next) => {
    Vue.http.post(domain("_isme")).then((res) => {
        if (res.body.parentId == '0') {
            // Vue.http.post(domain("_verifyPhone")).then((response) => {
            //     if (response.body.data.synFlag == '0') {
            //         next('/')
            //         return false;
            //     }
            // })
            Vue.http.post(domain("_mainIndex"),{emulateJSON: true}).then(function (response) {
                let { approveStatus = '0' } = response.body.data || {}
                store.commit('App/setApproveStatus', approveStatus)
                if (response.body.data.updateStatus === 1) {
                    Vue.prototype.$TsaAgreement.show({
                        title: '壹签服务协议',
                        url: response.body.data.oneSignAgreementUrl,
                        onConfirm: async () => {
                            Vue.prototype.$TsaLoading.show()
                            Vue.http.post(domain("_signProtocol")).then((res) => {
                                Vue.prototype.$TsaAgreement.hide()
                                Vue.prototype.$TsaLoading.hide()
                                next('/')
                            })
                        },
                        onCancel: () => {
                            Vue.prototype.$TsaAgreement.hide()
                             window.location.href='/api/logout';
                        }
                    })
                }
                if (response.body.data.synFlag == '0') {
                    next('/')
                    return false;
                }
                if (response.body.data.needSupplement === 1) {
                    next('/')
                    return false;
                }
            })
            next();
        } else {
            MessageBox.confirm('', {  
                message: '该账号为子账号，无法使用壹签服务',
                title: '提示',
                closeOnClickModal: false,
                confirmButtonText: '确定',
            }).then(action => {  
                if (action == 'confirm') { 
                    window.location.href = process.env.USER_ACCOUNT
                }
                return false;
            }).catch(err => {  
                window.location.href = process.env.USER_ACCOUNT
            });
        }

    }).catch((e) => {
        console.log(e)
            // var test = 'http://' + window.location.host + '/api/index';
            // window.location.href = process.env.USER_CENTER + '/login?redirectUrl=' + test;
        window.location.href = '/api/login'
    });
});




new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: { App }
})


// WEBPACK FOOTER //
// ./src/module/index/index.js